// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24; // 1 day
export const TOKEN_COOKIE = 'bb.token';
export const REFRESH_TOKEN_COOKIE = 'bb.refreshToken';
export const BADGES_STORAGE_KEY = 'bb.badges';
export const VERSION = 'v3.0.020';
export enum StageIds {
  STAGE_INSCRICAO = "6787f36de510835c7932e88c",
  STAGE_UM_AVALIACAO = "6787f39ee510835c7932e8a2",
  STAGE_DOIS_AVALIACAO = "6787f3e3e510835c7932e8c3",
  STAGE_TRES_AVALIACAO_DIRETOR = "6787f40ee510835c7932e8d4",
  STAGE_GANHADORES_ETAPA_2 = "67ee5e609a0db36354b6066c",
  STAGE_ENTREGA = "6787f43ce510835c7932e8e1",
  STAGE_AGUARDANDO_RESULTADO = "aguardando_resultado",
}